import {APIError} from '../core/errors';
import {
  paymentVerficationRequest,
  paymentVerificationResponse,
} from '../lib/types';
import httpClient from '../services/http.service';
import {BASE_URL, DEFAULT_HEADERS} from './api-constants';

const _api_base_url = `${BASE_URL}/order/verify-external-payment`;

export const paymenrVerificationApiCall = async (
  parameters: paymentVerficationRequest,
): Promise<paymentVerificationResponse> => {
  console.log(parameters);
  try {
    const response = await httpClient.post(
      `${_api_base_url}`,
      parameters.payload,
      {
        headers: {
          ...DEFAULT_HEADERS,
          Authorization: `Bearer ${parameters.accessToken}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw new APIError(error);
  }
};
